import { useState, useEffect } from 'react';
import { AppSettings, DEFAULT_SETTINGS, loadSettings, initializeSettings } from '../config/settings';
import { useAuth } from './useAuth';

export const useUserSettings = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState<AppSettings>(DEFAULT_SETTINGS);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadUserSettings = async () => {
      if (!user?.id) {
        setSettings(DEFAULT_SETTINGS);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const userSettings = await initializeSettings(user.id);
        setSettings(userSettings);
        setError(null);
      } catch (err) {
        console.error('Failed to load user settings:', err);
        setError('Failed to load user settings');
        setSettings(DEFAULT_SETTINGS);
      } finally {
        setIsLoading(false);
      }
    };

    loadUserSettings();
  }, [user?.id]);

  return {
    settings,
    isLoading,
    error,
    setSettings
  };
}; 